import styled from 'styled-components';

export const HeroContainer = styled.div`
background: #2a292c;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 30px;
  height: 100vh;
  position: relative;
  z-index: 1;

`;

export const HeroContent = styled.div`
  z-index: 3;
  max-width: 900px;
  position: absolute;
  padding: 8px 24px;
  margin-top: 150px;
  display: grid; 
  grid-template-columns: 1fr 1fr;
  grid-gap: 20px;

  @media screen and (max-width: 950px) {
    display: block;
  }
`;

export const ImageBg = styled.div`
  border-radius: 10px;
  z-index: 4;
  width: 400px;
  height: 400px;
  position: center;

  @media screen and (max-width: 950px) {
    width: 400px;
    height: 400px;
    padding: auto;
    margin: auto;
  }

  @media screen and (max-width: 768px) {
    width: 300px;
    height: 300px;
    padding: auto;
    margin: auto;
  }

  @media screen and (max-width: 480px) {
    font-size: 14px;
    width: 250px;
    height: 250px;
    padding: auto;
    margin: auto;
  }
`

export const PreviewImage = styled.img`
  border-radius: 10px;
  z-index: 4;
  width: 350px;
  height: 350px;

  @media screen and (max-width: 950px) {
    width: 400px;
    height: 400px;
    padding: auto;
    margin: auto;
  }
  
  @media screen and (max-width: 768px) {
    width: 300px;
    height: 300px;
    padding: auto;
    margin: auto;
  }

  @media screen and (max-width: 480px) {
    font-size: 14px;
    width: 250px;
    height: 250px;
    padding: auto;
    margin: auto;
  }
`

export const UserWrapper = styled.div`
  width: 100%;
  height: 100%;
  padding-top: 20px;
  vertical-align: center;
`

export const HeroH1 = styled.h1`
  color: #fff;
  font-size: 30px;
  text-align: center;

  @media screen and (max-width: 768px) {
    font-size: 20px;
  }

  @media screen and (max-width: 480px) {
    font-size: 20px;
  }
`;

export const HeroP = styled.p`
  margin-top: 24px;
  color: #fff;
  font-size: 24px;
  text-align: center;
  max-width: 600px;

  @media screen and (max-width: 768px) {
    font-size: 24px;
  }

  @media screen and (max-width: 480px) {
    font-size: 18px;
  }
`;

export const HeroP2 = styled.p`
  margin-top: 20px;
  color: #fff;
  font-size: 20px;
  text-align: center;
  max-width: 600px;
  line-height: 110%;
  font-kerning: none;

  @media screen and (max-width: 768px) {
    font-size: 20px;
  }

  @media screen and (max-width: 480px) {
    font-size: 14px;
  }
`;

export const HeroP3 = styled.p`
  margin-top: 20px;
  color: #fff;
  font-size: 18px;
  text-align: center;
  max-width: 600px;
  line-height: 22px;

  @media screen and (max-width: 768px) {
    font-size: 16px;
  }

  @media screen and (max-width: 480px) {
    font-size: 14px;
  }
`;


